// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"XY-z","inlineTitle":"YY-z","sponsoredAdsWrapper":"ZY-z","marketplaceRecosWrapper":"_Y-z"};